<template>
    <v-row>
        <v-col cols="12" class="title-section pb-0">
            {{ $t('common.competence') }}
        </v-col>
        <v-col cols="12">
            <div class="card-container">
                <v-col cols="12" class="subtitle-section">
                    {{ title }}
                </v-col>
                <loading-spinner height="140px" v-if="loading"/>
                <v-carousel v-else v-model="carousel" hide-delimiters :cycle="false" height="100%">
                    <v-carousel-item v-for="(competence, i) in competences" :key="i">
                        <v-row align="end">
                            <v-col :cols="1.5"/>
                            <v-col :cols="3" v-for="(student, j) in competence.students" :key="j"
                                   class="text-center pb-6">
                                <v-icon :size="j === 1 ? 50 : 25" :color="getColorIcon(j)" class="icon-container">
                                    {{ student.icon }}
                                </v-icon>
                                <div :class="['student-name mt-1 text-truncate', {'bolder': j === 1}]">
                                    {{ student.name }}
                                </div>
                                <div :class="['student-days', {'bolder': j === 1}]">
                                    {{ student.days }}
                                    {{ student.days ? $t('common.days') : $t('common.not_available_short') }}
                                </div>
                            </v-col>
                            <v-col :cols="1.5"/>
                        </v-row>
                    </v-carousel-item>
                </v-carousel>
            </div>
        </v-col>
    </v-row>
</template>

<script>
import LoadingSpinner from "@/components/common/LoadingSpinner";
import {db} from "@/utils/Firebase";

export default {
    name: "StudentCompetence",
    components: {LoadingSpinner},
    props: {
        coachId: {
            type: String,
            default: null,
        },
    },
    data(vm) {
        return {
            loading: false,
            carousel: 0,
            competences: [
                {
                    title: vm.$t('common.training_days_monthly'),
                    students: [
                        {name: vm.$t('common.not_available_short'), days: '', icon: 'mdi-medal-outline'},
                        {name: vm.$t('common.not_available_short'), days: '', icon: 'mdi-trophy-outline'},
                        {name: vm.$t('common.not_available_short'), days: '', icon: 'mdi-medal'},
                    ]
                },
                {
                    title: vm.$t('common.training_days_weekly'),
                    students: [
                        {name: vm.$t('common.not_available_short'), days: '', icon: 'mdi-medal-outline'},
                        {name: vm.$t('common.not_available_short'), days: '', icon: 'mdi-trophy-outline'},
                        {name: vm.$t('common.not_available_short'), days: '', icon: 'mdi-medal'},
                    ]
                },
            ],
        }
    },
    computed: {
        title(vm = this) {
            return vm.competences[vm.carousel]?.title || ''
        },
    },
    async mounted() {
        const vm = this
        await vm.loadCompetences()
    },
    methods: {
        async loadCompetences() {
            const vm = this
            vm.loading = true

            let studentsMonth = await db.collection('users')
                .where('studentSubscription.coachId', '==', vm.coachId)
                .where('counter.month', '>', 0)
                .orderBy('counter.month', 'desc')
                .limit(3)
                .get()

            if (studentsMonth.docs[0]) vm.setStudentInfo(studentsMonth.docs[0].data(), 'month', 1)
            if (studentsMonth.docs[1]) vm.setStudentInfo(studentsMonth.docs[1].data(), 'month', 0)
            if (studentsMonth.docs[2]) vm.setStudentInfo(studentsMonth.docs[2].data(), 'month', 2)

            let studentsWeek = await db.collection('users')
                .where('studentSubscription.coachId', '==', vm.coachId)
                .where('counter.week', '>', 0)
                .orderBy('counter.week', 'desc')
                .get()

            if (studentsWeek.docs[0]) vm.setStudentInfo(studentsWeek.docs[0].data(), 'week', 1)
            if (studentsWeek.docs[1]) vm.setStudentInfo(studentsWeek.docs[1].data(), 'week', 0)
            if (studentsWeek.docs[2]) vm.setStudentInfo(studentsWeek.docs[2].data(), 'week', 2)

            vm.loading = false
        },
        setStudentInfo(student, attribute, position) {
            const vm = this
            let competence = attribute === 'month' ? 0 : 1
            vm.competences[competence].students[position].name = student.name === vm.account?.name ? '(Tú)' : student.name
            vm.competences[competence].students[position].days = student.counter[attribute]
        },
        getColorIcon(index) {
            if (index === 0) return '#C0C0C0'
            if (index === 1) return '#D4AF37'
            if (index === 2) return '#CD7F32'
        }
    }
}
</script>

<style scoped>

.title-section {
    font-weight: 700;
    font-size: 20px;
    line-height: 22px;
}

.subtitle-section {
    font-weight: 700;
    font-size: 16px;
    line-height: 18px;
    text-align: center;
    border-bottom: thin solid rgba(0, 0, 0, 0.12);
    margin-bottom: 12px;
}

.card-container {
    border: thin solid rgba(0, 0, 0, 0.12);
    border-radius: 8px;
    overflow: hidden;
}

.student-name {
    font-size: 13px;
}

.student-days {
    font-size: 11px;
}

.icon-container {
    border: 4px solid currentColor;
    border-radius: 50%;
    padding: 8px;
}

</style>